import * as React from "react";
import { useHistory } from "react-router";

import { Group, PersonAdd } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Icon } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";
import { AgentsRoutes } from "routes/agents/constants";

interface IProps {
  canAddAgent: boolean;
  canAddTeam: boolean;
  isVisible: boolean;
  onHide(): void;
  onAddAgentSelect(): void;
  children: React.ReactElement;
}

const AgentsDropdown: React.FC<IProps> = ({
  isVisible,
  canAddAgent,
  canAddTeam,
  onHide,
  children,
  onAddAgentSelect,
}) => {
  const history = useHistory();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCreateTeamClick = () => {
    trackEngagement("Teams: Create team clicked", EventPlace.Teams, { source: "top-bar" });
    history.push(AgentsRoutes.AddTeam);
  };
  return (
    <ActionMenu
      triggerRenderer={children}
      visible={isVisible}
      onClose={onHide}
      placement="bottom-end"
      options={[
        ...(canAddAgent
          ? [
              {
                key: "invite-agents",
                element: <ActionMenuItem leftNode={<Icon source={PersonAdd} />}>Invite agents</ActionMenuItem>,
                onClick: onAddAgentSelect,
              },
            ]
          : []),
        ...(canAddTeam
          ? [
              {
                key: "create-team",
                element: <ActionMenuItem leftNode={<Icon source={Group} />}>Create team</ActionMenuItem>,
                onClick: handleCreateTeamClick,
              },
            ]
          : []),
      ]}
    />
  );
};

export default AgentsDropdown;
